import React, {useContext, useState} from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import SearchComponent from '../../../common/SearchComponent/SearchComponent';
import DeaccessionEntryOne from './DeaccessionEntryOne';
import {Form, Formik} from 'formik';
import {Button, Card, Grid} from '@mui/material';
import DeaccessionEntryTwo from './DeaccessionEntryTwo';
import DeaccessionEntryThree from './DeaccessionEntryThree';
import {Images} from '../../../common/Assets/Images';
import {catalogueApi} from '../../../services/CatalogueServices';
import {useNavigate} from 'react-router';
import {deaccessionApi} from '../../../services/DeaccessionServices';
import {DispatchContext} from '../../../store';
import {SNACKBAR_OPEN} from '../../../reducers';
import {useLocation} from 'react-router-dom';
import PageWrapper from '../../../common/PageWrapper/PageWrapper';
import * as Yup from 'yup';
import {messages} from '../../../common/Models/Validations';

const deaccessionValidationSchema = Yup.object().shape({
  translations: Yup.object().shape({
    en: Yup.object().shape({
      justification: Yup.string().required(messages.required),
    }),
  }),
});

const initialValue = {
  museum_id: '',
  accession_no: '',
  catalogue_id: '',
  submission_date: '',
  attachment_ids: '',
  translations: {
    en: {
      justification: ''
    }
  }
}

export default function DeaccessionCreate() {
  const dispatch = useContext(DispatchContext);
  const navigate = useNavigate();
  const [deaccession, setDeaccession] = useState(initialValue);
  const filteredDeaccession = deaccession?.[0];
  const code = 'en';
  const [searched, setSearched] = useState(false);

  const handleSearch = (searchAccession) => {
    catalogueApi('get', null, {
      search: searchAccession
    }).then(res => {
      setDeaccession({
        ...res?.data,
        translations: {
          en: {
            justification: ''
          }
        }
      });
    })
  };

  const handleClear = () => {
    setDeaccession([]);
  };

  const onSubmit = (values) => {
    const deaccessionValue = {
      museum_id: values?.museum_id,
      accession_no: values?.accession_no,
      catalogue_id: values?.id,
      submission_date: new Date().toISOString().slice(0, 10),
      attachment_ids: values?.attachments?.map((val) => val?.id),
      translations: {
        en: {
          justification: values?.translations?.en?.justification || ''
        }
      }
    }
    deaccessionApi('post', {...deaccessionValue}).then(res => {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'Deaccession created successfully'}
      });
      navigate(`/management/artifact-managements/${res?.data?.id}`)
    })
  }

  return (
    <PageWrapper>
      <Box sx={{display: {sm: 'flex', xs: 'column'}, alignItems: 'center', mt: 7, mb: 2}}>
        <Typography className={'text-500 font30'} sx={{color: '#757575'}}>Deaccession Request</Typography>
        <Box sx={{ml: {sm: 5, xs: 0}}}>
          <SearchComponent onSearch={handleSearch} searched={searched} setSearched={setSearched}
                           onClear={handleClear} placeholder={'Enter accession number'}/>
        </Box>
      </Box>
      <Box className={'header-divider'}/>
      <Formik initialValues={filteredDeaccession}
              onSubmit={onSubmit}
              validationSchema={deaccessionValidationSchema}
              validateOnBlur={true} enableReinitialize
      >
        {({isSubmitting, touched, errors, values, setFieldValue, ...formik}) => (
          <Form>
            {searched &&
            <>
              <Box>
                <Grid container spacing={2}>
                  <Grid item sm={4} xs={12}>
                    <DeaccessionEntryOne/>
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <DeaccessionEntryTwo code={code}/>
                  </Grid>
                  <Grid item sm={4} xs={12}>
                    <DeaccessionEntryThree code={code}/>
                  </Grid>
                </Grid>
                <Box className={'header-divider'} sx={{marginTop: 10, marginBottom: 10}}/>
                <Grid container spacing={2}>
                  <Grid item sm={4} xs={12}>
                    <Card className={'box-shadow'} sx={{p: 4}}>
                      <Grid container spacing={2}>
                        {values?.attachments?.length > 0 && values?.attachments?.map((val, index) => (
                          <Grid key={index} item sm={2.4} xs={12}>
                            <img src={val?.file || Images?.logoWhite} width={'100%'} alt="image"/>
                          </Grid>
                        ))}
                      </Grid>
                    </Card>
                  </Grid>
                </Grid>
              </Box>
              <Box>
                <Grid container spacing={2}>
                  <Grid item sm={9} xs={12}/>
                  <Grid item sm={3} xs={12}>
                    <Grid container spacing={2}>
                      <Grid item sm={6} xs={12}>
                        <Button onClick={() => navigate(-1)} variant={'outlined'} color={'error'}
                                fullWidth>Cancel</Button>
                      </Grid>
                      <Grid item sm={6} xs={12}>
                        <Button variant={'contained'} type={'submit'} fullWidth>Submit</Button>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Box>
            </>
            }
          </Form>
        )}
      </Formik>
    </PageWrapper>
  );
}